import { api_ } from '@shared/plugIn/axios';
import {
  TossConfirmPaymentParams,
  TossConfirmPaymentResponse,
} from '@shared/plugIn/tosspayments/types';

export const confirmTossPayment = async (params: TossConfirmPaymentParams) => {
  const { data } = await api_.post<TossConfirmPaymentResponse>(
    'public/shop-order/tosspayments/confirm',
    params,
  );
  return data;
};
